// import { SortableElement } from 'react-sortable-hoc';

import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Comp from './treeLeaf';

// Create context for drag handle props
const DragContext = React.createContext({});

// Wrapper component that uses the hook
const SortableWrapper = (props) => {
  const { index, children } = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `item-${index}`,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <DragContext.Provider value={{ listeners, attributes }}>
      <div ref={setNodeRef} style={style} {...attributes}>
        {children}
      </div>
    </DragContext.Provider>
  );
};

// Replacement for SortableElement that maintains the same HOC pattern
const SortableElement = (Component) => (props) =>
  (
    <SortableWrapper {...props}>
      <Component {...props} />
    </SortableWrapper>
  );

// Update the DragHandle to use context
export const DragHandle = () => {
  const { listeners, attributes } = React.useContext(DragContext);
  return (
    <div
      className="lifecycle-drag-handle"
      {...listeners}
      {...attributes}
      style={{ cursor: 'grab' }}
    >
      <span className="appkiticon icon-menu-outline" />
    </div>
  );
};

const sortableItem = SortableElement((props) => <Comp {...props} />);

export default sortableItem;
